"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = require("axios");
var _MapMetadata = _interopRequireDefault(require("./MapMetadata"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/**
 * An `MapResult` object contains response information about an AMP request.
 */
class MapResult {
  /**
   * Initializes a result instance with the necessary response information.
   *
   * @param response
   * @param image
   * @param error
   * @param params
   */
  constructor(response, image, error) {
    let params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    this.response = response;
    this.image = image;
    this.error = error;
    this.params = params;
    if (response && response.headers) {
      const headers = response.headers instanceof _axios.AxiosHeaders ? response.headers.toJSON() : response.headers;
      this.metadata = new _MapMetadata.default(headers);
    } else {
      this.metadata = new _MapMetadata.default({});
    }
  }
  /**
   * Returns the headers returned by the response, if any.
   */
  headers() {
    return this.response ? this.response.headers : undefined;
  }
}
var _default = exports.default = MapResult;
module.exports = exports.default;